import { Arrow } from '@public';
import { WorkItemType } from '@types';

import styles from './workItem.module.scss';

export interface WorkItemProps {
	work: WorkItemType;
	onItemClick: (auth: WorkItemType) => void;
	selected: boolean;
}

export const WorkItem = ({ work, onItemClick, selected }: WorkItemProps) => {
	const { status, reference, type } = work;
	return (
		<tr
			className={[styles.container, selected && styles['container-selected']].join(' ')}
			onClick={() => {
				onItemClick(work);
			}}
			role="row"
		>
			<td role="rowheader">{reference}</td>
			<td>{type}</td>
			<td>{status}</td>
			<td>
				<button
					className={styles.arrow}
					aria-label={['Select ', { reference }].join(' ')}
					tabIndex={0}
					onClick={() => {
						onItemClick(work);
					}}
				>
					<Arrow customStyles={styles.arrow} />
				</button>
			</td>
		</tr>
	);
};
